import { render, staticRenderFns } from "./Intro1.vue?vue&type=template&id=421a89cb&scoped=true"
import script from "./Intro1.vue?vue&type=script&lang=js"
export * from "./Intro1.vue?vue&type=script&lang=js"
import style0 from "./Intro1.vue?vue&type=style&index=0&id=421a89cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421a89cb",
  null
  
)

export default component.exports